<div class="view-bill-widget">
  <div class="header">
    <div class="title">{{ 'WIDGETS.MARRIOTT_VIEW_BILL.TITLE' | translate }}</div>
    <div class="subtitle">{{ 'WIDGETS.MARRIOTT_VIEW_BILL.SUBTITLE' | translate }}</div>
  </div>

  <div class="content" *ngIf="bill; else loadingOrError">
    <table class="bill-table">
      <thead>
        <tr>
          <th *ngIf="hasAnyDates">{{ 'WIDGETS.MARRIOTT_VIEW_BILL.TABLE.DATE' | translate }}</th>
          <th>{{ 'WIDGETS.MARRIOTT_VIEW_BILL.TABLE.DESCRIPTION' | translate }}</th>
          <th class="price-column">{{ 'WIDGETS.MARRIOTT_VIEW_BILL.TABLE.PRICE_TTC' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of paginatedItems">
          <td *ngIf="hasAnyDates">{{ item.date | date: 'dd/MM' }}</td>
          <td>
            <ng-container *ngIf="hasAnyQuantities">{{ item.quantity ?? '-' }} x </ng-container>{{ item.productName }}
          </td>
          <td class="price-column">
            <ng-container *ngIf="item.grossPriceInCents">
              {{ item.grossPriceInCents | centsToCurrency: bill.currency || 'EUR' }}
            </ng-container>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <ng-template #loadingOrError>
    <div class="content">
      <div class="loading-message" *ngIf="!billError">
        {{ 'WIDGETS.MARRIOTT_VIEW_BILL.LOADING' | translate }}
      </div>
      <div class="error-message" *ngIf="billError">
        {{ 'WIDGETS.MARRIOTT_VIEW_BILL.ERROR' | translate }}
      </div>
    </div>
  </ng-template>

  <div class="actions" *ngIf="bill">
    <button class="nav-button htv-selectable" [class.disabled]="!hasPreviousPage" (click)="previousPage()">
      ◀ {{ 'WIDGETS.MARRIOTT_VIEW_BILL.PREVIOUS_PAGE' | translate }}
    </button>

    <div class="page-indicator">
      {{ 'WIDGETS.MARRIOTT_VIEW_BILL.PAGE_INDICATOR' | translate: { current: currentPage + 1, total: totalPages } }}
    </div>

    <button class="nav-button htv-selectable" [class.disabled]="!hasNextPage" (click)="nextPage()">
      {{ 'WIDGETS.MARRIOTT_VIEW_BILL.NEXT_PAGE' | translate }} ▶
    </button>
  </div>
</div>
